enum IconKey{

    home='home-icon',
    add='add-icon',
    minus='minus-icon',
    singleplay='single-play',
    autoplay='auto-play'
}
export default IconKey